document.addEventListener('DOMContentLoaded', function (event) {
    function tableBody({ label, quantity = 'Quantity', price = 'Price' }) {
        let tableBodyTag = document.createElement("div");
        tableBodyTag.classList.add("multivariants_block_last_holder_table_body");
        tableBodyTag.innerHTML = `
            <div class="multivariants_block_last_holder_labels">${label}</div>
            <div class="table-head-quantity">${quantity}</div>
            <div class="table-head-price">${price}</div>
      `
        return tableBodyTag
    }
    function beforeInputCheck(title, label, newClass) {
        let spanTag = label.querySelector(`.${newClass}-label-value`);
        if (spanTag == null) {
            spanTag = document.createElement("span");
            spanTag.classList.add(`${newClass}-label-value`);
            spanTag.classList.add(`label-value-title`);
            spanTag.textContent = title;
            label.appendChild(spanTag)
        }
        // if(newClass == 'metal') {
        //   let tableHead = document.querySelector('.multivariants_block_option_label.size').parentNode;
        //     document.querySelector(`fieldset input[value='${title}']`)
        //     tableHead.appendChild(tableBody());
        // }
        spanTag.textContent = title;

    }
    function inputCheck(value, label, title, newClass) {
        beforeInputCheck(title, label, newClass);
        if (document.querySelector(`fieldset input[value='${title}']`)) {
            document.querySelector(`fieldset input[value='${title}']`).click();
        }

        selectMultiVariantsOption(value);
    }


    // let productTags = {{ product.tags | json }};
    function initMultivariants(productTags) {
        let arrowIconRight = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none"><path d="M8.9362 8.72261H4.26953V10.2782H8.9362H10.4918H15.1584V8.72261H10.4918H8.9362Z" fill="#121331"/></svg>`;
        let arrowIconLeft = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none"><path d="M9.50944 4.056V8.72268H4.84277V10.2782H9.50944V14.9449H11.065V10.2782H15.7317V8.72268H11.065V4.056H9.50944Z" fill="#121331"/></svg>`;
        let intervalArrow = setInterval(() => {
            let arrowRight = [...document.querySelectorAll('.multivariants_block_qty_box_right')];
            let arrowLeft = [...document.querySelectorAll('.multivariants_block_qty_box_left')];

            if (document.querySelector('.multivariants_setbox_body') && arrowLeft.length & arrowRight.length) {
                arrowRight.forEach((arrow) => {
                    arrow.innerHTML = arrowIconRight;
                });
                arrowLeft.forEach((arrow) => {
                    arrow.innerHTML = arrowIconLeft;
                });
                if (productTags.includes('stone')) {
                    let optionLabels = [...document.querySelectorAll('.multivariants_block_option_label')];
                    optionLabels.forEach((label, index) => {
                        let newClass = label.innerText.toLowerCase().split(' ').join('-');
                        if (newClass) {
                            label.classList.add(newClass);
                            label.nextSibling.classList.add(`${newClass}-wrap`);
                            let inputs = [...label.nextSibling.querySelectorAll('input[type=radio]')];
                            let swatchLabels = [...label.nextSibling.querySelectorAll('.multivariants_swatch_label')]
                            inputs.forEach((input, idx) => {
                                input.onchange = function () {
                                    let title = swatchLabels[idx].innerText;
                                    inputCheck(this.value, label, title, newClass);
                                };
                            });

                        }
                    });
                    let tableHeads = [...document.querySelector('.multivariants_block_select_holder.option-select-holder').parentNode.children].filter((item, idx) => idx !== 0)
                    let lableText = document.querySelector('.multivariants_block_option_list.option-list .multivariants_block_label_holder .multivariants_block_option_label .mkmid_m')?.innerText;
                    if (lableText) {
                        tableHeads.forEach((tableHead) => {
                            if (tableHead.querySelector('.multivariants_block_select_holder.option-select-holder')) {
                                tableHead.querySelector('.multivariants_block_select_holder.option-select-holder').append(tableBody({ label: lableText }))
                            } else {
                                tableHead.prepend(tableBody({ label: lableText }))
                            }
                        });

                    } else {
                        clearInterval(intervalArrow);
                    }
                }
                if (productTags.includes('posts')) {
                    const swatchHolderChildrens = [...document.querySelector('.swatch-holder-wrap').children]
                    const lists = [...document.querySelectorAll('.multivariants_block_option_list.multivariants_block_option_level_0.multivariants_0_block_option_level_0.option-list')]
                    swatchHolderChildrens.forEach((swatch, idx) => {
                        lists[idx].prepend(tableBody({ label: 'Size' }))
                        swatch.appendChild(lists[idx])
                        if (!swatch.querySelector('.multivariants_swatch').classList.contains('custom-swatch-label-wrap')) {
                            swatch.querySelector('.multivariants_swatch').classList.add('custom-swatch-label-wrap')
                            swatch.querySelector('.multivariants_swatch').innerHTML += `<svg class="multy-arrow-list" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M1.69271 12.9372C1.84126 12.9337 1.98239 12.8716 2.08529 12.7644L9.00008 5.84958L15.9149 12.7644C15.9673 12.8184 16.03 12.8613 16.0994 12.8906C16.1687 12.9199 16.2432 12.935 16.3184 12.935C16.4304 12.935 16.5398 12.9016 16.6326 12.839C16.7255 12.7765 16.7975 12.6877 16.8396 12.5839C16.8817 12.4802 16.8919 12.3662 16.8688 12.2567C16.8458 12.1471 16.7906 12.047 16.7103 11.969L9.39779 4.65646C9.29229 4.55101 9.14924 4.49178 9.00008 4.49178C8.85092 4.49178 8.70787 4.55101 8.60238 4.65646L1.28988 11.969C1.20808 12.0475 1.15191 12.1489 1.12874 12.2598C1.10557 12.3708 1.11647 12.4862 1.16002 12.5909C1.20357 12.6956 1.27774 12.7847 1.37279 12.8465C1.46785 12.9083 1.57936 12.9399 1.69271 12.9372Z" fill="#121331"></path></svg>`
                        }
                    })
                }
                // document.querySelector('.EFOLI_APP_MULTIVARIANTS_BLOCK_PRODUCT_PLACE').style.display = 'block';
                clearInterval(intervalArrow);
            }
        }, 500);
    }
    let productTags = window.productTags;
    initMultivariants(productTags);

})